__webpack_public_path__ = `https://front-assets.madlan.co.il/static/${window.__LOCALIZE_SSR_CONFIG__.version}/`